// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/common.css'
import '../static/css/hotel_common.css'
import '../static/font_menu/iconfont.css'
import router from './router/index'
import store from './store'
// import V from 'v-distpicker'
import VDistpicker from 'v-distpicker'
import FastClick from 'fastclick';


// import AudioPlayer from '@liripeng/vue-audio-player'
// import '@liripeng/vue-audio-player/lib/vue-audio-player.css'
import md5 from 'js-md5';
import moment from 'moment'
import VideoPlayer from 'vue-video-player'
import lrz from 'lrz'
import {
  getRequest
} from './api/http'
import {
  postRequest
} from './api/http'
import {
  deleteRequest
} from './api/http'
import {
  putRequest
} from './api/http'
import {
  uploadFileRequest
} from './api/http'
import {
  downFileRequest
} from './api/http'
import allFn from '../src/global/global'
import base from './api/baseUrl'
import imgUrl from './api/imgUrl'
import '../static/js/rem'
import VueAspectRatio from "vue-aspect-ratio";
import lodash from 'lodash'

import vRometeJs from './api/remote-js'
Vue.use(vRometeJs)


import {
  Popup,
  List,
  PullRefresh
} from 'vant';
import * as XLSX from 'xlsx';
console.log(XLSX)
Vue.use(XLSX)
Vue.use(Popup);
Vue.use(List);
Vue.use(PullRefresh);
FastClick.attach(document.body);
// 引入videojs
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// import Video from 'video.js';
// import 'video.js/dist/video-js.css';
// Vue.prototype.$video = Video;
// import 'videojs-flash'; // 要播放rtmp流, 就必须引入videojs-flash

// import hls from 'videojs-contrib-hls';
// Vue.use(hls); // 要播放hls流, 就必须引入videojs-contrib-hls

Vue.component('v-distpicker', VDistpicker);
// Vue.use(AudioPlayer)

Vue.config.productionTip = false;
Vue.prototype.$md5 = md5;

Vue.prototype.lrz = lrz

Vue.component("vue-aspect-ratio", VueAspectRatio)

Vue.use(ElementUI);
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.downFileRequest = downFileRequest;
Vue.prototype.$moment = moment;
Vue.prototype.$allFn = allFn;
Vue.prototype.$baseUrl = base;
Vue.prototype.$imgUrl = imgUrl;
Vue.prototype.$lodash = lodash
function isThemeTypeValid(themeType) {
  return [3, 5, 6].includes(themeType);
}
function isQsThemeTypeValid(themeType) {
  return [7,8].includes(themeType);
}
function isNotExpired(hwModel) {
  const allowedModels = ['LUX_F1', 'LUX_F1Pro', 'LUX_F6', 'LUX_F60', 'F60'];
  return allowedModels.includes(hwModel);
}
//统一判断是否是栅格类型的主题
Vue.prototype.$isThemeTypeValid = isThemeTypeValid;
//统一判断是否是轻奢类型的主题
Vue.prototype.$isQsThemeTypeValid = isQsThemeTypeValid;
Vue.prototype.$isNotExpired = isNotExpired;
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL)
})

Vue.filter('datefmt', function (input, fmtstring) {
  if(input==32472115200){
    return "终身授权生效中"
  }
  return moment.unix(input).format(fmtstring)
})
Vue.directive('focus', {
  bind: function (el) {
    // el.focus()
  },
  inserted: function (el) { // inserted 表示元素插入到DOM中的时候，会执行 inserted 函数【触发1次】
    el.focus()
    // 和JS行为有关的操作，最好在 inserted 中去执行，放置 JS行为不生效
  },
  updated: function (el) { // 当VNode更新的时候，会执行 updated，可能会触发多次

  }
})

Vue.prototype.$textLength = function (contentLength, num) {
  if (contentLength == num) {
    this.$message({
      message: '不能超过' + contentLength + '个字',
      type: 'warning'
    });
  }
};

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js